import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ZoomImagePage } from './zoom-image.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [ZoomImagePage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ZoomImagePageModule { }
